<div [style.filter]="showLoader === true ? 'blur(0.2rem)' : 'blur(0)'"></div>
<div fxLayout="column" class="content-style-class">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="column">
      <h2 class="title-style">{{ dataService.res("Ubt-User-Rights") }}</h2>
    </div>
  </div>
  <div class="content-block project-container">
    <div class="dx-card responsive-paddings card-radius">
      <abc-grid
        #rolesGrid
        class="grid-group-by-Style chech-box-Column custome-export-style"
        [height]="'100%'"
        [noDataText]="noDataText"
        [hoverStateEnabled]="false"
        [showRowLines]="false"
        [setupDefaultLayoutOnInitialization]="true"
        [columns]="columnsHeader"
        [dataSource]="dataSource"
        (onCellPrepared)="onCellPrepared($event)"
        (onCellClick)="onCellClick($event)"
        (onExporting)="dataService.onExporting($event, exportFileName)"
      >
        <dxo-export
          [enabled]="true"
          [allowExportSelectedData]="false"
          [formats]="['pdf', 'xlsx']"
        ></dxo-export>
        <dxo-column-chooser [enabled]="false"> </dxo-column-chooser>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-editing [allowAdding]="false"> </dxo-editing>
        <dxo-state-storing [enabled]="false"></dxo-state-storing>

        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-filter-panel [visible]="true"> </dxo-filter-panel>
        <dxo-search-panel [visible]="true"> </dxo-search-panel>
      </abc-grid>
    </div>
  </div>
</div>
<abc-context-menu
  #contextMenu
  id="contextMenu"
  class="abc-context-menu"
  showEvent="abcclick"
  [items]="contextMenuItems"
  [position]="{ my: 'top right', at: 'bottom right' }"
>
</abc-context-menu>
@if(loadPopup()){
  <ubt-user-right-popup
    #createUserPopup
    [loadPopup]="loadPopup()"
    (closePopup)="loadPopup.set($event)"
  ></ubt-user-right-popup>
}

@if (showLoader) {
  <ubt-loader></ubt-loader>
}
